module.exports = __webpack_public_path__ + "img/Danger.f8c3f25f.svg";